// extracted by mini-css-extract-plugin
export default {"container":"P5-z","title":"Q5-z","link":"R5-z"};